import { render, staticRenderFns } from "./imageAndText.vue?vue&type=template&id=7190f4c6&scoped=true"
import script from "./imageAndText.vue?vue&type=script&lang=js"
export * from "./imageAndText.vue?vue&type=script&lang=js"
import style0 from "./imageAndText.vue?vue&type=style&index=0&id=7190f4c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7190f4c6",
  null
  
)

export default component.exports